import { Component, Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

import { authorFields, rtcCardColorField } from 'organisms/Cards/config';

const quoteCardFields = [
  {
    name: 'quote',
    type: 'richText',
    defaultValue:
      '<p><strong>Prismatic beautifully supports</strong> the model we wanted: technical support staff configure new instances of known integrations; software engineers get involved when theres something new; support staff can monitor whats happening day-to-day.”</p>',
    required: true,
    helperText: 'Main testimonial or quote text. Supports rich formatting like bold or italic.',
  },
  imageField('companyLogo'),
  {
    name: 'author',
    type: 'object',
    subFields: authorFields,
    required: true,
    helperText: 'Information about the person being quoted (name, title, headshot).',
  },
  rtcCardColorField,
] as const satisfies DeepReadonly<Input[]>;

const quoteCardConfig = {
  name: 'quoteCard',
  inputs: quoteCardFields,
} as Component;

export type QuoteCardConfigProps = GenerateBuilder<typeof quoteCardFields>;

export default quoteCardConfig;
